import {checkbox, required} from "./field-rules";

export default [
  {
    name: "login",
    attrs: {
      type: "text",
      label: "Логин",
      required: true
    },
    rules: [required]
  },
  {
    name: "allowConsent",
    attrs: {
      type: "checkbox",
      label: "Я даю согласие на обработку персональных данных",
      required: true
    },
    rules: [checkbox]
  }
];
